import moment from "moment";

/**
 * The admin API encrypts every value, so numbers and booleans arrive as strings ("3", "true").
 * These helpers turn them back; sockets send real numbers/booleans, so both shapes must work.
 */
export const toBool = (value) =>
  value === true || value === "true" || value === 1 || value === "1";

export const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

/** Chat time in the panel's fixed IST wall clock (same rule as utils/dateFormate#dateTimeFormat). */
export const formatChatTime = (date) => {
  if (!date) return "";
  const parsed = moment.utc(date);
  return parsed.isValid()
    ? parsed.utcOffset(330).format("DD MMM, hh:mm A")
    : "";
};

export const formatRelativeTime = (date) => {
  if (!date) return "";
  const parsed = moment.utc(date);
  return parsed.isValid()
    ? parsed.utcOffset(330).format("DD-MM-YYYY hh:mm A")
    : "";
};

export const MESSAGE_MAX_LENGTH = 4000;

export const MESSAGE_TYPE = {
  TEXT: "text",
  IMAGE: "image",
  VIDEO: "video",
  DOCUMENT: "document",
  FILE: "file",
};

export const isMediaType = (type) =>
  [MESSAGE_TYPE.IMAGE, MESSAGE_TYPE.VIDEO, MESSAGE_TYPE.DOCUMENT, MESSAGE_TYPE.FILE].includes(type);

// Matches http(s):// and www. links; trailing punctuation is trimmed off the link below
const LINK_PATTERN = /((?:https?:\/\/|www\.)[^\s<]+)/gi;
const TRAILING_PUNCTUATION = /[.,;:!?)\]}'"]+$/;

/**
 * Splits text into plain and link parts: [{ text }, { text, href }]. Only http(s) links become clickable
 * (a `www.` link gets https://), so message text can never produce a javascript: link.
 */
export const splitLinks = (text) => {
  const source = String(text ?? "");
  const parts = [];
  let last = 0;
  for (const match of source.matchAll(LINK_PATTERN)) {
    const raw = match[0];
    const url = raw.replace(TRAILING_PUNCTUATION, "");
    if (match.index > last) parts.push({ text: source.slice(last, match.index) });
    parts.push({
      text: url,
      href: /^www\./i.test(url) ? `https://${url}` : url,
    });
    last = match.index + url.length;
  }
  if (last < source.length) parts.push({ text: source.slice(last) });
  return parts;
};

// Same types the server accepts for an admin attachment, and its size limit
export const ATTACHMENT_ACCEPT =
  "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv";
export const ATTACHMENT_MAX_BYTES = 100 * 1024 * 1024;
